import {TrackReferenceOrPlaceholder} from "@livekit/components-core/src/track-reference";
import {Participant, Track} from "livekit-client";

export function sortTrackReferencesCustom(
    tracks: TrackReferenceOrPlaceholder[],
): TrackReferenceOrPlaceholder[] {
    const localTracks: TrackReferenceOrPlaceholder[] = [];
    const screenShareTracks: TrackReferenceOrPlaceholder[] = [];
    const cameraTracks: TrackReferenceOrPlaceholder[] = [];
    const undefinedTracks: TrackReferenceOrPlaceholder[] = [];

    tracks.forEach((trackRef) => {
        if (trackRef.participant.isLocal && trackRef.source === Track.Source.Camera) {
            localTracks.push(trackRef);
        } else if (trackRef.source === Track.Source.ScreenShare) {
            screenShareTracks.push(trackRef);
        } else if (trackRef.source === Track.Source.Camera) {
            cameraTracks.push(trackRef);
        } else {
            undefinedTracks.push(trackRef);
        }
    });

    const sortedCameraTracks = sortCameraTracks(cameraTracks);

    return [...localTracks, ...screenShareTracks, ...sortedCameraTracks, ...undefinedTracks];
}

function sortCameraTracks(
    cameraTrackReferences: TrackReferenceOrPlaceholder[],
): TrackReferenceOrPlaceholder[] {
    const localCameraTracks: TrackReferenceOrPlaceholder[] = [];
    const remoteCameraTracks: TrackReferenceOrPlaceholder[] = [];
    const mentorCameraTracks: TrackReferenceOrPlaceholder[] = [];

    cameraTrackReferences.forEach((trackRef) => {
        if (trackRef.participant.identity === "mentor") {
            mentorCameraTracks.push(trackRef)
        } else if (trackRef.participant.isLocal) {
            localCameraTracks.push(trackRef);
        } else {
            remoteCameraTracks.push(trackRef);
        }
    });

    remoteCameraTracks.sort((a, b) => {
        // A participant that joined a long time ago goes before one that joined recently.
        return sortParticipantsByJoinedAt(a.participant, b.participant);
    });

    return [...localCameraTracks, ...mentorCameraTracks, ...remoteCameraTracks];
}

function sortParticipantsByJoinedAt(
    a: Pick<Participant, 'joinedAt'>,
    b: Pick<Participant, 'joinedAt'>,
) {
    return (a.joinedAt?.getTime() ?? 0) - (b.joinedAt?.getTime() ?? 0);
}